import type { GridQueryInput } from '@/ui/composites/grid/gridUtils';
import type { QueryResult } from '@flowqa/shared';

type TableQueryFactoryOptions<TSortKey extends string, TExtra extends object, TResult> = {
  extras: TExtra;
  query: (input: GridQueryInput & TExtra) => Promise<QueryResult<TResult>>;
  sortDirection: 'asc' | 'desc';
  sortFieldMap: Record<TSortKey, string>;
  sortKey: TSortKey;
};

const buildExecutionRunsPageTableQuery = <TSortKey extends string, TExtra extends object, TResult>({
  extras,
  query,
  sortDirection,
  sortFieldMap,
  sortKey,
}: TableQueryFactoryOptions<TSortKey, TExtra, TResult>) => {
  return async (input: GridQueryInput): Promise<QueryResult<TResult>> => {
    const inputSorts = input.sorts;
    const sorts =
      inputSorts.length > 0
        ? inputSorts
        : [
            {
              field: sortFieldMap[sortKey],
              direction: sortDirection,
            },
          ];

    return await query({
      ...input,
      ...extras,
      sorts,
    });
  };
};

export { buildExecutionRunsPageTableQuery };
